import { render, staticRenderFns } from "./PortfolioPanel.vue?vue&type=template&id=4055bfdc&scoped=true&"
import script from "./PortfolioPanel.vue?vue&type=script&lang=js&"
export * from "./PortfolioPanel.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioPanel.vue?vue&type=style&index=0&id=4055bfdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055bfdc",
  null
  
)

export default component.exports